import { TrackingRegion } from './TrackingData';

export const renderRegionTracking = (regionId?: TrackingRegion) =>
  regionId
    ? {
        'data-region-id': regionId,
      }
    : {};
